import axios, { type AxiosInstance } from 'axios';

import { applyCustomErrorInterceptor } from '../BaseApiClient/applyCustomErrorInterceptor';

/**
 * Dedicated HTTP client for the Rise FOS track-conversion API.
 *
 * Does NOT include 401 redirect interceptor to preserve fail-silent pattern.
 * Conversion tracking failures should be logged but never disrupt user experience.
 */
export class ConversionTrackingHttpClient {
  private client: AxiosInstance | null = null;

  constructor(private baseURL: string, private authToken: string) {}

  public getClient(): AxiosInstance {
    if (!this.client) {
      this.client = axios.create({
        baseURL: this.baseURL,
        headers: {
          Authorization: `Bearer ${this.authToken}`,
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Cache-Control': 'no-store',
        },
        withCredentials: false,
      });

      applyCustomErrorInterceptor(this.client);
    }

    return this.client;
  }
}
